var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ width: _vm.videoWidth, height: _vm.videoHeight })},[_c('video',{staticClass:"video-js",staticStyle:{"width":"100%","height":"100%"},attrs:{"id":_vm.videoId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }